import React from "react";
import "./confirmModal.css"; // Create and style this CSS file

function ConfirmModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h1>Confirm Deletion</h1>
        <p>Are you sure you want to delete this item?</p>
        <div className="modal-buttons">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button onClick={onConfirm} className="delete-btn">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
